import type { TabProps } from '@chakra-ui/react';
import {
  Box,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/react';
import { TopUpTab } from '@ui/views/card-cronos/core/types';
import { useCdcCardView } from '@ui/views/card-cronos/core/utils';
import { useTranslations } from 'next-intl';
import type { FC } from 'react';

import { TopUp } from './TopUp';
import { TopUpHistory } from './TopUpHistory';

export const TopUpAndHistory = () => {
  const t = useTranslations();
  const { topUpTab, setTopUpTab } = useCdcCardView();
  return (
    <Box>
      <Text
        w="fit-content"
        mx="auto"
        textStyle="h2"
        bg="gradients.white-blue-title"
        bgClip="text"
        textAlign="center"
      >
        {t('card.Crypto-com Card Top Up')}
      </Text>
      <Tabs
        variant="unstyled"
        border="1px solid rgba(255, 255, 255, 0.10)"
        rounded="8px"
        p="3"
        bgColor="rgba(255, 255, 255, 0.05)"
        index={topUpTab === TopUpTab.History ? 1 : 0}
        onChange={(index) =>
          setTopUpTab(index === 1 ? TopUpTab.History : TopUpTab.TopUp)
        }
        isFitted
        mt={{
          base: '24px',
          desktop: '40px',
        }}
        isLazy
        lazyBehavior="unmount"
      >
        <TabList>
          <StyledTab>{t('card.Top Up')}</StyledTab>
          <StyledTab>{t('card.History')}</StyledTab>
        </TabList>
        <TabPanels pt="40px">
          <TabPanel p={0}>
            <TopUp />
          </TabPanel>
          <TabPanel p={0}>
            <Box px="5">
              <TopUpHistory />
            </Box>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

const StyledTab: FC<TabProps> = (props) => (
  <Tab
    _selected={{
      color: '#159DFF',
      fontWeight: '700',
      borderBottom: '2px solid #159DFF',
    }}
    _hover={{
      background:
        'radial-gradient(ellipse 60% 100% at center, #159DFF 0%, transparent 70%)',
      _selected: {
        background:
          'linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #159DFF 49.32%, rgba(255, 255, 255, 0.00) 97.77%) bottom left / 95% 1px no-repeat',
      },
      _disabled: {
        background: 'initial',
      },
    }}
    {...props}
  />
);
